import request from "@/utils/request";

export default function checkMerchantNews(params) {
    return request({
        url: `/news/agency/check/merchantNews`,
        method: 'post',
        data:params
    })
}
